
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airlines/reviews",
      function () {
        return require("private-next-pages/airlines/reviews.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airlines/reviews"])
      });
    }
  